<template>
  <div id="company-location-info" class="component">
    <form-status :v="$v" />
    <!-- <form submit.prevent novalidate> -->
      <!-- Primary Company Contact Section -->
      <div class="row">
        <div class="col-md-12">
          <!-- company primary contact changed-->
          <div v-if="company.commercialLicenseRenewal" class="row">
            <div class="col-md-12">
              <div class="row"><label class="col-md-8 control-label required"> Has your company primary contact changed? </label></div>
              <div class="renewal-radio-btns mb-3">
                <div class="radio-btn">
                  <input
                    id="primaryContactChangedYes"
                    v-model="company.companyLocation.primaryContactChanged"
                    type="radio"
                    :value="true"
                  />
                  <label for="primaryContactChangedYes">Yes</label>
                </div>
                <div class="radio-btn">
                  <input id="primaryContactChangedNo" v-model="company.companyLocation.primaryContactChanged" type="radio" :value="false" />
                  <label for="primaryContactChangedNo">No</label>
                </div>
              </div>
              </div>
          </div>
          <div v-if = "!(company.commercialLicenseRenewal && !company.companyLocation.primaryContactChanged)">
            <div class="row">
              <div class="form-group col-md-12"><label for="" class="control-label">Primary Company Contact:</label></div>
            </div>
            <div class="row">
              <div class="col-md-3 form-group">
                <label for="contactFirstName" class="control-label required">First Name</label>
                <input
                  id="contactFirstName"
                  v-model="company.companyLocation.contactDetails.primaryCntFirstName"
                  name="contactFirstName"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.contactDetails.primaryCntFirstName.$touch()"
                />
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntFirstName.required &&
                      $v.company.companyLocation.contactDetails.primaryCntFirstName.$error
                  "
                  class="text-danger"
                >
                  Please enter valid First Name
                </div>
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntFirstName.maxLength &&
                      $v.company.companyLocation.contactDetails.primaryCntFirstName.$error
                  "
                  class="text-danger"
                >
                  Allowed upto 100 characters only
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label for="contactMiddleName" class="control-label">Middle Name</label>
                <input
                  id="contactMiddleName"
                  v-model="company.companyLocation.contactDetails.primaryCntMdlName"
                  name="contactMiddleName"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.contactDetails.primaryCntMdlName.$touch()"
                />
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntMdlName.maxLength &&
                      $v.company.companyLocation.contactDetails.primaryCntMdlName.$error
                  "
                  class="text-danger"
                >
                  Allowed upto 100 characters only
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label for="contactLastName" class="control-label required">Last Name</label>
                <input
                  id="contactLastName"
                  v-model="company.companyLocation.contactDetails.primaryCntLastName"
                  name="contactLastName"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.contactDetails.primaryCntLastName.$touch()"
                />
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntLastName.required &&
                      $v.company.companyLocation.contactDetails.primaryCntLastName.$error
                  "
                  class="text-danger"
                >
                  Please enter valid Last Name
                </div>
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntLastName.maxLength &&
                      $v.company.companyLocation.contactDetails.primaryCntLastName.$error
                  "
                  class="text-danger"
                >
                  Allowed upto 100 characters only
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 form-group">
                <label for="contactEmail" class="control-label required">Email Address</label>
                <input
                  id="contactEmail"
                  v-model="company.companyLocation.contactDetails.primaryCntEmail"
                  name="contactEmail"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.contactDetails.primaryCntEmail.$touch()"
                />
                <div
                  v-if="
                    (!$v.company.companyLocation.contactDetails.primaryCntEmail.required ||
                      !$v.company.companyLocation.contactDetails.primaryCntEmail.email) &&
                      $v.company.companyLocation.contactDetails.primaryCntEmail.$error
                  "
                  class="text-danger"
                >
                  Please enter valid email address
                </div>
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntEmail.maxLength &&
                      $v.company.companyLocation.contactDetails.primaryCntEmail.$error
                  "
                  class="text-danger"
                >
                  Allowed upto 150 characters only.
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label for="contactPhoneNumber" class="control-label required">Phone Number</label>
                <input
                  id="contactPhoneNumber"
                  v-model="company.companyLocation.contactDetails.primaryCntPhNo"
                  name="contactPhoneNumber"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.contactDetails.primaryCntPhNo.$touch()"
                />
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntPhNo.maxLength &&
                      $v.company.companyLocation.contactDetails.primaryCntPhNo.$error
                  "
                  class="text-danger"
                >
                  Allowed upto 15 characters only
                </div>
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntPhNo.required &&
                      $v.company.companyLocation.contactDetails.primaryCntPhNo.$error
                  "
                  class="text-danger"
                >
                  Please enter valid phone number
                </div>
              </div>              
              <div class="col-md-3 form-group">
                <label for="contactJobTitle" class="control-label required">Job Title</label>
                <input
                  id="contactJobTitle"
                  v-model="company.companyLocation.contactDetails.primaryCntJobTitle"
                  name="contactJobTitle"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.contactDetails.primaryCntJobTitle.$touch()"
                />
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntJobTitle.maxLength &&
                      $v.company.companyLocation.contactDetails.primaryCntJobTitle.$error
                  "
                  class="text-danger"
                >
                  Allowed upto 200 characters only
                </div>
                <div
                  v-if="
                    !$v.company.companyLocation.contactDetails.primaryCntJobTitle.required &&
                      $v.company.companyLocation.contactDetails.primaryCntJobTitle.$error
                  "
                  class="text-danger"
                >
                  Please enter valid job title
                </div>
              </div>
            </div>
            <!-- Portal Access Desired Field -->
            <div class="row form-group">
              <div class="col-md-9">
                <label class="checkbox-inline">
                  <input id="portalAccess" v-model="company.companyLocation.contactDetails.portalAccess" type="checkbox" />
                  Portal Access Desired?
                </label>
              </div>
            </div>
            <!-- Country of Citizenship & US Green Card Holder & Green Card Expiry Date Field -->
            <div v-if="company.companyLocation.contactDetails.portalAccess" class="row">
              <!-- Country of Citizenship Field -->
              <div class="col-md-3 form-group">
                <label for="citizenshipCountry" class="control-label required">Country of Citizenship</label>
                <select
                  id="citizenshipCountry"
                  v-model="company.companyLocation.contactDetails.citizenshipCountry"
                  class="form-control"
                  @blur="$v.company.companyLocation.contactDetails.citizenshipCountry.$touch();"
                  @change="displayGreenCard"
                >
                  <option value="">Please select country</option>
                  <option v-for="country in countries" :key="country.cntryId" :value="country.cntryId">
                    {{ country.cntryNm }}
                  </option>
                </select>
                <div v-if="!$v.company.companyLocation.contactDetails.citizenshipCountry.required 
                            && $v.company.companyLocation.contactDetails.citizenshipCountry.$error" class="text-danger">
                Please select country of citizenship
                </div>
              </div>
              <!-- US Green Card Holder Field -->
              <div v-if="showGreenCardDetails" class="col-md-3 form-group">
                <label class="control-label required" for="greenCard">US Green Card Holder?</label>                
                <select id="greenCard" v-model="company.companyLocation.contactDetails.greenCard" class="form-control">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <!-- Green Card Expiry Date Field -->
              <div v-if="showGreenCardDetails && company.companyLocation.contactDetails.greenCard == 'Yes'" class="col-md-3 form-group">
                <label class="control-label required" for="greenCardExpiry">Expiration Date</label>
                <datepicker
                  id="greenCardExpiry"
                  v-model.trim="company.companyLocation.contactDetails.greenCardExpiry"
                  v-focus
                  placeholder="(MM/DD/YYYY)"
                  :bootstrap-styling="true"
                  format="MM/dd/yyyy"
                  @blur="$v.company.companyLocation.contactDetails.greenCardExpiry.$touch();"
                ></datepicker>
                <div v-if="!$v.company.companyLocation.contactDetails.greenCardExpiry.required 
                            && $v.company.companyLocation.contactDetails.greenCardExpiry.$error" class="text-danger">
                  Please select expiration date
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Address Section -->
      <div class="row">
        <div class="form-group col-md-12">
           <!-- company address changed-->
          <div v-if="company.commercialLicenseRenewal" class="row">
            <div class="col-md-12">
              <div class="row"><label class="col-md-8 control-label required"> Has your company address changed? </label></div>
              <div class="renewal-radio-btns mb-3">
                <div class="radio-btn">
                  <input
                    id="companyAddressChangedYes"
                    v-model="company.companyLocation.companyAddressChanged"
                    type="radio"
                    :value="true"
                  />
                  <label for="companyAddressChangedYes">Yes</label>
                </div>
                <div class="radio-btn">
                  <input id="companyAddressChangedNo" v-model="company.companyLocation.companyAddressChanged" type="radio" :value="false" />
                  <label for="companyAddressChangedNo">No</label>
                </div>
              </div>
              </div>
          </div>
          <div v-if = "!(company.commercialLicenseRenewal && !company.companyLocation.companyAddressChanged)">
            <div class="row">              
              <div class="col-md-3 form-group">
                <label for="legalAddressLine1" class="control-label required">Legal Address Line 1</label>
                <input
                  id="legalAddressLine1"
                  v-model="company.companyLocation.legalAddress.line1"
                  name="legalAddressLine1"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.legalAddress.line1.$touch()"
                />
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.line1.required &&
                                                $v.company.companyLocation.legalAddress.line1.$error">
                  Please enter legal address line 1
                </div>
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.line1.maxLength &&
                                                $v.company.companyLocation.legalAddress.line1.$error">
                  Allowed upto 500 characters only
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label for="city" class="control-label required">City</label>
                <input
                  id="city"
                  v-model="company.companyLocation.legalAddress.city"
                  name="city"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.legalAddress.city.$touch()"
                />
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.city.required &&
                                                $v.company.companyLocation.legalAddress.city.$error">
                  Please enter city
                </div>
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.city.maxLength &&
                                                $v.company.companyLocation.legalAddress.city.$error">
                  Allowed upto 100 characters only
                </div>
              </div>
            </div>
            <div class="row">              
              <div class="col-md-3 form-group">
                <label for="legalAddressLine2" class="control-label">Legal Address Line 2</label>
                <input
                  id="legalAddressLine2"
                  v-model="company.companyLocation.legalAddress.line2"
                  name="legalAddressLine2"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.legalAddress.line2.$touch()"
                />
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.line2.maxLength &&
                                                $v.company.companyLocation.legalAddress.line2.$error">
                  Allowed upto 500 characters only
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label for="country" class="control-label required">Country</label>
                <select
                  id="country"
                  v-model="company.companyLocation.legalAddress.country"
                  name="country"
                  class="form-control"
                  @blur="$v.company.companyLocation.legalAddress.country.$touch()"
                  @change="countryChanged"
                >
                  <option value="">Select Country</option>
                  <option v-for="country in countries" :key="country.cntryId" :value="country.cntryId">
                    {{ country.cntryNm }}
                  </option>
                </select>
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.country.required &&
                                                $v.company.companyLocation.legalAddress.country.$error">
                  Please select country
                </div>
              </div>
            </div>
            <div class="row">              
              <div class="col-md-3 form-group">
                <label for="legalAddressLine3" class="control-label">Legal Address Line 3</label>
                <input
                  id="legalAddressLine3"
                  v-model="company.companyLocation.legalAddress.line3"
                  name="legalAddressLine3"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.legalAddress.line3.$touch()"
                />
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.line3.maxLength &&
                                                $v.company.companyLocation.legalAddress.line3.$error">
                  Allowed upto 500 characters only
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label for="state" class="control-label required">State/Province/Region</label>
                <input
                  id="state"
                  v-model="company.companyLocation.legalAddress.state"
                  name="state"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.legalAddress.state.$touch()"
                />
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.state.required &&
                                                $v.company.companyLocation.legalAddress.state.$error">
                  Please enter state/province/region
                </div>
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.state.maxLength &&
                                                $v.company.companyLocation.legalAddress.state.$error">
                  Allowed upto 100 characters only
                </div>
              </div>
            </div>
            <div class="row">              
              <div class="col-md-3 form-group">
                <label for="legalAddressLine4" class="control-label">Legal Address Line 4</label>
                <input
                  id="legalAddressLine4"
                  v-model="company.companyLocation.legalAddress.line4"
                  name="legalAddressLine4"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.legalAddress.line4.$touch()"
                />
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.line4.maxLength &&
                                                $v.company.companyLocation.legalAddress.line4.$error">
                  Allowed upto 500 characters only
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label for="zipCode" class="control-label required">Zip/Postal Code</label>
                <input
                  id="zipCode"
                  v-model="company.companyLocation.legalAddress.zipCode"
                  name="zipCode"
                  type="text"
                  class="form-control"
                  @blur="$v.company.companyLocation.legalAddress.zipCode.$touch()"
                />
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.zipCode.required &&
                                                $v.company.companyLocation.legalAddress.zipCode.$error">
                  Please enter zip/postal code
                </div>
                <div class="text-danger" v-if="!$v.company.companyLocation.legalAddress.zipCode.maxLength &&
                                                $v.company.companyLocation.legalAddress.zipCode.$error">
                  Allowed upto 20 characters only
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <label class="checkbox-inline">
                  <input id="shippingAddressSame" v-model="company.companyLocation.shippingAddressSame" type="checkbox" />
                  Shipping Address same as Legal Address
                </label>
              </div>
              <div v-show = "!company.companyLocation.shippingAddressSame" class="form-group col-md-12">
                <shipping-address :v="$v" @shippingCarrierDetailsStatus="shippingCarrierDetailsStatus"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <label class="checkbox-inline">
                  <input id="billingAddressSame" v-model="company.companyLocation.billingAddressSame" type="checkbox" />
                  Billing Address same as Legal Address
                </label>
              </div>
              <div v-show = "!company.companyLocation.billingAddressSame" class="form-group col-md-12"><billing-address :v="$v" /></div>
            </div>
            <div v-if = "company.companyLocation.shippingAddressSame" class="row form-group">
              <carrier-details :address = company.companyLocation.legalAddress :index = 0 @carrierDetailsStatus="carrierDetailsStatus" />
            </div>
          </div>
        </div>
      </div>
      <div class="action-btns row">
        <div class="col-md-6">
          <input type="submit" class="btn btn-sm btn-primary" value="Next" @click="submitForm" />
        </div>
      </div>
    <!-- </form> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import tooltip from "build-ui-x/src/Tooltip";
import { requiredIf, maxLength, email } from "vuelidate/lib/validators";
import formStatus from "@/mycfm/components/new-company/FormStatus";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import shippingAddress from "@/mycfm/components/new-company/ShippingAddress";
import billingAddress from "@/mycfm/components/new-company/BillingAddress";
import carrierDetails from "@/mycfm/components/new-company/CarrierDetails";
import { CarrierDetails } from "@/model/CarrierDetails";


export default {
  components: {
    tooltip,
    formStatus,
    Datepicker,
    shippingAddress,
    billingAddress,
    carrierDetails
  },
  data() {
    return {
      isComLocCompleted: false,
      isValidCarrierDetails: false
    };
  },
  computed: {
    ...mapState("country", ["countries"]),
    ...mapState("company", ["company"]),
    //show Green Card and Exipry Date field except US and empty country
    showGreenCardDetails() {
      return this.$store.state.company.company.companyLocation.contactDetails.portalAccess 
              && this.$store.state.company.company.companyLocation.contactDetails.citizenshipCountry != 232
              && this.$store.state.company.company.companyLocation.contactDetails.citizenshipCountry != "";
    }
  },
  watch: {
    "company.companyLocation.companyAddressChanged": function(newVal) {
      if (!newVal) {
        this.$store.dispatch("company/clearLegalAddress");
        this.$store.dispatch("company/clearShippingAddress");
        this.$store.dispatch("company/clearBillingAddress");
        this.$v.company.companyLocation.$reset();
      }
    },
    "company.companyLocation.primaryContactChanged": function(newVal) {
      if (!newVal) {
        this.$store.dispatch("company/clearcontactDetails");
        this.$v.company.companyLocation.$reset();
      }
    },
    "company.companyLocation.contactDetails.portalAccess": function(newVal) {
      //reset form validation and Country of Citizenship & US Green Card Holder & Green Card Expiry Date field 
      //when portal access checkbox unchecked
      if (!newVal) {
        this.$store.dispatch("company/clearPortalAccessDetails");
        this.$v.company.companyLocation.$reset();
      }
    },
    "company.companyLocation.contactDetails.greenCard": function(newVal) {
      //reset Green Card Expiry Date when US Green Card Holder changed
      this.$store.state.company.company.companyLocation.contactDetails.greenCardExpiry = "";
    },
    "company.companyLocation.shippingAddressSame": {
      handler: function(newVal) {
        this.$store.dispatch("company/clearLegalCarrierDetails");
        if (newVal) {
          this.$store.dispatch("company/clearShippingAddress");
          this.$v.company.companyLocation.$reset();
        }
      }
    },
    "company.companyLocation.billingAddressSame": {
      handler: function(newVal) {
        if (newVal) {
          this.$store.dispatch("company/clearBillingAddress");
          this.$v.company.companyLocation.$reset();
        }
      }
    }
  },
  created() {
    this.$store.dispatch("country/getCountries");
    this.$store.dispatch("carrierList/getCarrierList");
    this.$emit("companyLocCompleted", this.isComLocCompleted);
    if (this.$store.state.vuealidate.hasOwnProperty("Company Location Information")) {
      this.$v.$touch();
    }
    //format Green Card Expiry Date if data present
    if (this.$store.state.company.company.companyLocation.contactDetails.greenCardExpiry) {
      this.company.companyLocation.contactDetails.greenCardExpiry = 
              moment(this.$store.state.company.company.companyLocation.contactDetails.greenCardExpiry).format(
                      "YYYY-MM-DD"
                    );
    }
  },
  beforeDestroy() {
    this.$v.$touch();
    this.$store.dispatch("vuealidate/saveValidation", {
      componentName: "Company Location Information",
      $v: this.$v
    });
  },
  validations: {
    company: {
      companyLocation: {
        contactDetails: {
          primaryCntFirstName: {
            maxLength: maxLength(100),
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.primaryContactChanged);
            })
          },
          primaryCntMdlName: {
            maxLength: maxLength(100)
          },
          primaryCntLastName: {
            maxLength: maxLength(100),
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.primaryContactChanged);
            })
          },
          primaryCntPhNo: {
            maxLength: maxLength(15),
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.primaryContactChanged);
            })
          },
          primaryCntEmail: {
            email,
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.primaryContactChanged);
            }),
            maxLength: maxLength(150)
          },
          primaryCntJobTitle: {
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.primaryContactChanged);
            }),
            maxLength: maxLength(200)
          },
          citizenshipCountry: {
            required: requiredIf(function() {
              return this.company.companyLocation.contactDetails.portalAccess;
            })
          },
          greenCardExpiry: {
            required: requiredIf(function() {
              return this.company.companyLocation.contactDetails.portalAccess && this.company.companyLocation.contactDetails.greenCard === "Yes";
            })
          }
        },
        legalAddress: {
          line1: {
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged);
            }),
            maxLength: maxLength(500)
          },
          line2: {
            maxLength: maxLength(500)
          },
          line3: {
            maxLength: maxLength(500)
          },
          line4: {
            maxLength: maxLength(500)
          },
          city: {
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged);
            }),
            maxLength: maxLength(100)
          },
          country: {
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged);
            })
          },
          state: {
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged);
            }),
            maxLength: maxLength(100)
          },
          zipCode: {
            required: requiredIf(function() {
              return !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged);
            }),
            maxLength: maxLength(20)
          },
        },
        shippingAddress: {
          required: requiredIf(function() {
            return (
              !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
              !this.company.companyLocation.shippingAddressSame
            );
          }),
          $each: {
            firstName: {
              maxLength: maxLength(100),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              })
            },
            middleName: {
              maxLength: maxLength(100)
            },
            lastName: {
              maxLength: maxLength(100),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              })
            },
            emailAddress: {
              maxLength: maxLength(150),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              }),
              email
            },
            phoneNumber: {
              maxLength: maxLength(15),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              })
            },
            jobTitle: {
              maxLength: maxLength(200),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              })
            },
            line1: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              }),
              maxLength: maxLength(500)
            },
            line2: {
              maxLength: maxLength(500)
            },
            line3: {
              maxLength: maxLength(500)
            },
            line4: {
              maxLength: maxLength(500)
            },
            city: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              }),
              maxLength: maxLength(100)
            },
            country: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              }),
            },
            state: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              }),
              maxLength: maxLength(100)
            },
            zipCode: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.shippingAddressSame
                );
              }),
              maxLength: maxLength(20)
            }
          }
        },
        billingAddress: {
          required: requiredIf(function() {
            return (
              !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
              !this.company.companyLocation.billingAddressSame
            );
          }),
          $each: {
            firstName: {
              maxLength: maxLength(100),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              })
            },
            middleName: {
              maxLength: maxLength(100)
            },
            lastName: {
              maxLength: maxLength(100),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              })
            },
            emailAddress: {
              maxLength: maxLength(150),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              }),
              email
            },
            phoneNumber: {
              maxLength: maxLength(15),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              })
            },
            jobTitle: {
              maxLength: maxLength(200),
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              })
            },
            line1: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              }),
              maxLength: maxLength(500)
            },
            line2: {
              maxLength: maxLength(500)
            },
            line3: {
              maxLength: maxLength(500)
            },
            line4: {
              maxLength: maxLength(500)
            },
            city: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              }),
              maxLength: maxLength(100)
            },
            country: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              }),
            },
            state: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              }),
              maxLength: maxLength(100)
            },
            zipCode: {
              required: requiredIf(function() {
                return (
                  !(this.company.commercialLicenseRenewal && !this.company.companyLocation.companyAddressChanged) &&
                  !this.company.companyLocation.billingAddressSame
                );
              }),
              maxLength: maxLength(20)
            }
          }
        },
        carrierDetails: {
          required: requiredIf(function() {
            return this.isValidCarrierDetails
          })       
        }
      }
    }
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      this.$emit("next", "CompanyLocation");
    },
    //called when country changed 
    displayGreenCard: function(event) {
      //reset for US or empty country selection
      if(event.target.value == 232 || event.target.value == "") {
        this.$store.state.company.company.companyLocation.contactDetails.greenCard = "No";
        this.$store.state.company.company.companyLocation.contactDetails.greenCardExpiry = "";
      }
      this.$store.state.company.company.companyLocation.contactDetails.citizenshipCountry = event.target.value;
    },
    //keep track of legal carrier details is vaild or not
    carrierDetailsStatus(object) {
      this.isValidCarrierDetails = object.status
    },
    //keep track of shipping carrier details is vaild or not
    shippingCarrierDetailsStatus(status) {
      this.isValidCarrierDetails = status
    },
    countryChanged() {
      this.company.companyLocation.legalAddress.carrierDetails = new CarrierDetails()
    }
  }
};
</script>

<style lang="less" scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.renewal-radio-btns {
  padding-left: 10px;
  .radio-btn {
    display: inline-block;
    margin-right: 20px;
    label {
      vertical-align: bottom;
      margin-left: 5px;
      font-weight: normal;
    }
  }
}
.mb-3 {
  margin-bottom: 15px;
}
.checkbox-inline {
  font-weight: bold;
  input[type="checkbox"] {
    cursor: pointer;
  }
}
</style>
